export default {"src":"/_next/static/media/level-all.63db50cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};